import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const KEY = "spectraloom_cookie_banner_dismissed";

// Lightweight cookie banner · dismissible, no external tracking to gate.
// We only use localStorage, so this is more of a courtesy notice.
export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch { /* ignore */ }
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-[90] card-elev p-4 flex items-start gap-3 shadow-xl fade-up"
      data-testid="cookie-banner"
      role="region"
      aria-label={t("cookies.banner_aria")}
    >
      <Cookie size={18} className="text-[color:var(--brand)] mt-0.5 shrink-0" />
      <div className="flex-1 text-sm text-[color:var(--fg-secondary)] leading-relaxed">
        {t("cookies.banner_text")}{" "}
        <Link to="/legal/cookies" className="text-[color:var(--brand)] underline">
          {t("cookies.banner_link")}
        </Link>
        .
      </div>
      <button
        onClick={dismiss}
        className="p-1 rounded-md hover:bg-white/5"
        aria-label={t("cookies.banner_dismiss")}
        data-testid="cookie-banner-dismiss"
      >
        <X size={16} />
      </button>
    </div>
  );
}
